import { createRoot } from 'react-dom/client';
import 'bootstrap/dist/css/bootstrap.css';
import 'react-slideshow-image/dist/styles.css';
import { ThemeProvider } from '@mui/material';
import { GlobalStyles } from './Assets/GlobalStyles';
import App from './App';

const rootElement = document.getElementById('root')!;
const root = createRoot(rootElement);

root.render(
    <ThemeProvider theme={GlobalStyles}>
        <App />
    </ThemeProvider>
);
